import {
  getDefaultMiddleware,
  configureStore,
  applyMiddleware,
} from "@reduxjs/toolkit";
import { reducers } from "./rootReducers";
import logger from "redux-logger";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  timeout: 0,
  key: "root",
  storage: storage,
};

const middleware:any = [
  ...getDefaultMiddleware({
    serializableCheck: false,
  }),
];

if (process.env.NODE_ENV == "development") {
  middleware.push(logger);
}

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware,
});

export type AppDispatch = typeof store.dispatch;
export default store;
export const persistor = persistStore(store);
